import { render, staticRenderFns } from "./cells_small.vue?vue&type=template&id=f32b7eae&scoped=true&"
import script from "./cells_small.vue?vue&type=script&lang=js&"
export * from "./cells_small.vue?vue&type=script&lang=js&"
import style0 from "./cells_small.vue?vue&type=style&index=0&id=f32b7eae&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f32b7eae",
  null
  
)

export default component.exports